import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { useEffect } from 'react'

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
      api_host: 'https://eu.i.posthog.com',
      capture_pageview: false, // We'll handle this with React Router
      capture_exceptions: true,
    })

    posthog.register({
      app_version: import.meta.env.VITE_APP_VERSION || 'unknown',
      environment: import.meta.env.MODE,
    })
  }, [])

  return <PHProvider client={posthog}>{children}</PHProvider>
}


